const isValidHex = (hex) => {
  const hexWithoutHash = hex.startsWith('#') ? hex.slice(1) : hex;
  return /^[0-9A-Fa-f]{3}$|^[0-9A-Fa-f]{6}$/.test(hexWithoutHash);
};

export default isValidHex;
